import Header from "../components/landing/Header";
import HeroLeadPrzyklad from "../components/landing/HeroLeadPrzyklad";
import TrustStrip from "../components/landing/TrustStrip";
import BenefitsListSection from "../components/landing/BenefitsListSection";
import HowItWorksFotowoltaika from "../components/landing/HowItWorksFotowoltaika";
import RealizacjeSection from "../components/landing/RealizacjeSection";
import ReviewsSection from "../components/landing/ReviewsSection";
import FAQPrzyklad from "../components/landing/FAQPrzyklad";
import FinalCTAFotowoltaika from "../components/landing/FinalCTAFotowoltaika";
import Footer from "../components/landing/Footer";
import MobileStickyCTA from "../components/landing/MobileStickyCTA";
import { PageProvider } from "../config/PageContext";
import { Lightbulb, BadgeCheck, Hammer } from "lucide-react";

const NAV_LINKS = [
  { id: "dlaczego", label: "Dlaczego warto" },
  { id: "jak-to-dziala", label: "Jak to działa" },
  { id: "realizacje", label: "Realizacje" },
  { id: "faq", label: "FAQ" },
];

const FOOTER_NAV_LINKS = [
  { id: "jak-to-dziala", label: "Jak to działa" },
  { id: "realizacje", label: "Realizacje" },
  { id: "faq", label: "FAQ" },
];

const TRUST_ITEMS = [
  { icon: Lightbulb, label: "Jasny proces montażu" },
  { icon: BadgeCheck, label: "Bezpłatna konsultacja" },
  { icon: Hammer, label: "Montaż nawet w 21 dni" },
];

const FOOTER_DESCRIPTION = "Przykładowa strona nowoczesnej firmy fotowoltaicznej.";

const FOOTER_LOCALIZATION = "Obsługujemy: Warszawa, Radom, Łódź, Kielce i okolice.";

const BENEFITS_POINTS = [
  "Dobieramy instalację do Twojego domu",
  "Jasny proces — od pierwszej rozmowy aż do uruchomienia",
  "Decyzję podejmujesz spokojnie, bez nacisku",
];

export default function PrzykladStronyPage() {
  return (
    <PageProvider value="PRZYKLAD">
      <div
        className="min-h-screen bg-white text-brand-ink font-body overflow-x-hidden"
        data-testid="przyklad-strony-page"
      >
        <Header ctaLabel="Zostaw numer" navLinks={NAV_LINKS} />
        <main>
          <HeroLeadPrzyklad />
          <TrustStrip items={TRUST_ITEMS} />
          <BenefitsListSection points={BENEFITS_POINTS} eyebrow={null} />
          <HowItWorksFotowoltaika />
          <RealizacjeSection />
          <ReviewsSection />
          <FAQPrzyklad />
          <FinalCTAFotowoltaika />
        </main>
        <Footer
          description={FOOTER_DESCRIPTION}
          navLinks={FOOTER_NAV_LINKS}
          localization={FOOTER_LOCALIZATION}
        />
        <MobileStickyCTA label="Zostaw numer" />
      </div>
    </PageProvider>
  );
}
